export const quickAnswer =
  'Protect the karaoke attempt with the nine directions, or check the post-story progression needed for the extra combat slot.';

## Two Focused Trophy Guides

The karaoke guide lists directions without reproducing lyrics. The Combat Readiness guide explains progression and the extra ability unlock.

## Before Attempting a Trophy

Read the prerequisite and retry notes before committing. Save availability can affect whether an unsuccessful attempt can be repeated.
